// No imports: tests read index.html against these values.

/**
 * The boot guard: a tiny inline script in `index.html`'s <head>
 * (`<script id="boot-guard">`) that hides the page until React has rendered,
 * on the app host and on any path that is not a marketing page.
 *
 * Why: Vercel serves the prerendered landing page as `index.html`. The bare
 * app host (`app.bidcontext.ai/`, a filesystem hit) and every unknown path
 * (the `/(.*)` catch-all) get that file, so the landing page painted for a
 * second before React redirected to /login or "/". Marketing pages on www are
 * never hidden, so crawlers and first paint there are unchanged.
 *
 * The script is allowed by a sha256 hash in the page's CSP (index.html). Any
 * edit to it must update the hash — `boot-guard.test.ts` checks both.
 */

/** The <style> element the boot guard adds; removing it shows the page. */
export const BOOT_HIDE_STYLE_ID = 'boot-hide'

/** The host that serves only the app (routes.tsx sends its "/" to /login). */
export const APP_HOSTNAME = 'app.bidcontext.ai'

/** Show the page the boot guard hid. Called once React has committed its first render. */
export function revealAfterBoot(): void {
  document.getElementById(BOOT_HIDE_STYLE_ID)?.remove()
}
